import { Label } from '@wix/answers-api';
import { HIDDEN_ARTICLE_LABEL } from '@wix/wix-chatbot-common/src/articles';

export const getIsArticleHidden = (articleLabels: Label[] | undefined): boolean => {
  if (!articleLabels) {
    return false;
  }
  return !!articleLabels.find((label) => label.id === HIDDEN_ARTICLE_LABEL);
};
